export default {
    emeric: "'Emeric', 'Emeric Fallback'",
    emericItalic: "'Emeric Italic', 'Emeric Italic Fallback'",
    emericMedium: "'Emeric Medium', 'Emeric Medium Fallback'",
    emericCore: "'Emeric Core', 'Emeric Medium Fallback'",
    emericLight: "'Emeric Light', 'Emeric Light Fallback'",
    emericBook: "'Emeric Book', 'Emeric Book Fallback'",
} as const;
